// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"e13a0c4a","859":"e13a0c4a"}[chunkId] + ".chunk.css";
};